// Palette mirrors the prototype's fitracking-style tokens. These feed Mantine style props
// (`bg`, `c`); the `*.module.scss` files next to each component use the `_variables.scss`
// twins of the same values ($gray-200, $type-light-primary, $type-light-secondary, $collar-yellow).
export const NEUTRAL = '#f3f3f2';
export const INK = '#000000';
export const GRAY = '#737373';
export const LINE = '#e5e5e4';
export const YELLOW = '#fffa01';
